import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=65c0c312&scoped=true&"
import script from "./LikeButton.vue?vue&type=script&lang=ts&"
export * from "./LikeButton.vue?vue&type=script&lang=ts&"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=65c0c312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0c312",
  null
  
)

export default component.exports